import React, { useState } from 'react';
import { Link } from 'react-router-dom';

/**
 * Header.jsx — beige-theme redesign. Drop-in replacement. Self-contained.
 * Keeps react-router navigation + scroll-to-section. Light theme only
 * (the old dark/light toggle is removed to match the new design).
 */
const BotMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
    <rect x="2" y="2" width="96" height="96" rx="26" fill="#C0492A" />
    <line x1="50" y1="20" x2="50" y2="31" stroke="#fff" strokeWidth="4.5" strokeLinecap="round" />
    <circle cx="50" cy="15" r="5.5" fill="#1A1A18" />
    <rect x="25" y="31" width="50" height="44" rx="15" fill="#fff" />
    <rect x="34" y="42" width="32" height="22" rx="9" fill="#1A1A18" />
    <circle cx="44.5" cy="53" r="4" fill="#5E6B39" />
    <circle cx="57.5" cy="53" r="4" fill="#5E6B39" />
  </svg>
);

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollToSection = (id) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = `/#${id}`;
    }
  };

  return (
    <header className="cai-hd">
      <div className="cai-hd-inner">
        <Link to="/" className="cai-hd-logo" onClick={() => setMobileOpen(false)}>
          <BotMark />
          <span className="cai-hd-name">Custodian<span style={{ color: '#C0492A' }}>AI</span> Automation</span>
        </Link>

        <nav className="cai-hd-nav">
          <Link className="cai-hd-link" to="/">Home</Link>
          <Link className="cai-hd-link" to="/products">Products</Link>
          <Link className="cai-hd-link" to="/case-studies">Case Studies</Link>
          <button className="cai-hd-link cai-hd-link-btn" onClick={() => scrollToSection('about-us')}>About</button>
          <button className="cai-hd-cta" onClick={() => scrollToSection('booking')}>BOOK A DEMO</button>
        </nav>

        <button className="cai-hd-burger" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu">
          {mobileOpen ? '✕' : '☰'}
        </button>
      </div>

      {mobileOpen && (
        <div className="cai-hd-mobile">
          <Link className="cai-hd-mlink" to="/" onClick={() => setMobileOpen(false)}>Home</Link>
          <Link className="cai-hd-mlink" to="/products" onClick={() => setMobileOpen(false)}>Products</Link>
          <Link className="cai-hd-mlink" to="/case-studies" onClick={() => setMobileOpen(false)}>Case Studies</Link>
          <button className="cai-hd-mlink cai-hd-mlink-btn" onClick={() => scrollToSection('about-us')}>About</button>
          <button className="cai-hd-cta cai-hd-cta-mobile" onClick={() => scrollToSection('booking')}>BOOK A DEMO</button>
        </div>
      )}

      <style>{`
        .cai-hd { position: sticky; top: 0; z-index: 100; background: rgba(236,234,227,0.85); backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px); border-bottom: 1px solid rgba(0,0,0,0.06); }
        .cai-hd-inner { max-width: 1200px; margin: 0 auto; padding: 14px 40px; display: flex; align-items: center; justify-content: space-between; }
        .cai-hd-logo { display: flex; align-items: center; gap: 11px; text-decoration: none; color: #1A1A18; }
        .cai-hd-name { font-size: 18px; font-weight: 800; letter-spacing: -0.02em; }
        .cai-hd-nav { display: flex; align-items: center; gap: 22px; }
        .cai-hd-link { background: none; border: none; cursor: pointer; font-family: inherit; font-size: 15px; font-weight: 500; color: #4A463E; text-decoration: none; padding: 0; transition: color .15s; }
        .cai-hd-link:hover { color: #C0492A; }
        .cai-hd-link-btn { background: none; border: none; cursor: pointer; font-family: inherit; font-size: 15px; font-weight: 500; color: #4A463E; padding: 0; transition: color .15s; }
        .cai-hd-link-btn:hover { color: #C0492A; }
        .cai-hd-mlink-btn { background: none; border: none; text-align: left; cursor: pointer; font-family: inherit; font-size: 16px; font-weight: 500; color: #1A1A18; padding: 10px 0; width: 100%; }
        .cai-hd-cta { border: none; cursor: pointer; background: #C0492A; color: #fff; font-family: inherit; font-size: 14px; font-weight: 700; letter-spacing: 0.04em; padding: 12px 22px; border-radius: 10px; transition: background .2s; }
        .cai-hd-cta:hover { background: #A53D22; }
        .cai-hd-burger { display: none; background: none; border: none; font-size: 22px; cursor: pointer; color: #1A1A18; }
        .cai-hd-mobile { display: none; }
        @media (max-width: 940px) {
          .cai-hd-nav { display: none; }
          .cai-hd-burger { display: block; }
          .cai-hd-mobile { display: flex; flex-direction: column; gap: 4px; padding: 12px 22px 18px; background: #ECEAE3; border-top: 1px solid rgba(0,0,0,0.06); }
          .cai-hd-mlink { background: none; border: none; text-align: left; cursor: pointer; font-family: inherit; font-size: 16px; font-weight: 500; color: #1A1A18; text-decoration: none; padding: 10px 0; }
          .cai-hd-cta-mobile { margin-top: 8px; }
        }
      `}</style>
    </header>
  );
};

export default Header;
